export default __webpack_public_path__ + "static/media/Run (4).d7aa0668.png";